import React from 'react';
import { useTheme } from '../../../../context/themeContext';
import { R } from '../../../../R';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function FavoriteSortItem(props: any) {
  const Direction = R.drawables.general.Ic_location;
  const Home = R.drawables.general.Ic_home;
  const Work = R.drawables.general.Ic_WorkSmall;
  const SortIcon = R.drawables.general.Ic_Drag;
  const theme = useTheme();

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.direction.id
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      className={'favorite-station-container'}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}>
      <div className={'favorite-station-body-c'}>
        <div className={'row'} style={{justifyContent: 'space-between'}}>
          <div className={'row'}>
            <div
              className={'agency-icon-box poiIcon'}
              style={{ backgroundColor: theme.colors.mediumDark }}>
              {props.direction.typeId == 3 ? (
                <Work style={{ fill: 'white' }} />
              ) : props.direction.typeId == 2 ? (
                <Home style={{ fill: 'white' }} />
              ) : (
                <Direction style={{ fill: 'white' }} />
              )}
            </div>
            <div className={'subtitle'} >{props.direction?.alias}</div>
          </div>
          {/* incluir zona para ordenar */}
          <SortIcon />    
          
        </div>
        <div className={'cornerText marginTop5'} style={{textAlign: 'left'}}>{props.direction?.direction}</div>
      </div>
    </div>
  );
}
